module.exports = __webpack_public_path__ + "static/media/Minun_gaussian2.10bdddb2.png";